import { sortBy } from 'lodash-es';
import { createSelector } from 'redux-bundler';

export const selectAllTeamMemberIDs = ({ teams }) => teams?.base?.allIDs || [];
export const selectTeamMembersById = ({ teams }) => teams?.base?.byId || {};

export const selectTeamMembersByIdWithoutChatbot = createSelector(
  'selectTeamMembersById',
  (teamMembersById) =>
    Object.values(teamMembersById || []).filter(
      ({ role }) => role !== 'Chatbot',
    ),
);

export const selectTeamMemberIDsByOrganization = ({ teams }) =>
  teams?.byOrganization || {};
export const selectTeamMemberIDsByBoard = ({ teams }) => teams?.byBoard || {};

export const selectTeamMemberIDsByCurrentOrganization = createSelector(
  'selectTeamMemberIDsByOrganization',
  'selectCurrentOrganizationId',
  (teamMemberIDsByOrganization, currentOrganizationId) =>
    teamMemberIDsByOrganization?.[currentOrganizationId] || [],
);

export const selectTeamMembersByCurrentOrganization = createSelector(
  'selectTeamMemberIDsByCurrentOrganization',
  'selectTeamMembersById',
  'selectBoardIDsByCurrentOrganization',
  (
    teamMemberIDsByCurrentOrganization,
    teamMembersById,
    boardIDsByCurrentOrganization,
  ) => {
    const teamMembersByCurrentOrganization = [];

    for (
      let i = 0, l = teamMemberIDsByCurrentOrganization.length;
      i < l;
      i += 1
    ) {
      const teamMember = teamMembersById[teamMemberIDsByCurrentOrganization[i]];
      if (teamMember) {
        teamMembersByCurrentOrganization.push({
          ...teamMember,
          assignedBoardIDs:
            teamMember?.assignedBoardIDs?.filter((id) =>
              boardIDsByCurrentOrganization.includes(id),
            ) ?? [],
        });
      }
    }

    return teamMembersByCurrentOrganization;
  },
);

export const selectTeamMembersByCurrentOrganizationSortedByDisabled =
  createSelector(
    'selectTeamMembersByCurrentOrganization',
    (teamMembersByCurrentOrganization) =>
      teamMembersByCurrentOrganization.length
        ? sortBy(teamMembersByCurrentOrganization, ['disabled'])
        : [],
  );

const getNumberOfActiveMembers = (teamMembers) =>
  teamMembers.reduce(
    (acc, { disabled, pending }) => (disabled || pending ? acc : acc + 1),
    0,
  );

// number of team members on an account
export const selectNumberOfActiveTeamMembers = createSelector(
  'selectTeamMembersByCurrentOrganization',
  (teamMembers) => getNumberOfActiveMembers(teamMembers),
);

export const selectTeamMembersByCurrentOrganizationSortedByDisabledWithoutChatbot =
  createSelector(
    'selectTeamMembersByCurrentOrganizationSortedByDisabled',
    (teamMembers) => teamMembers.filter(({ role }) => role !== 'Chatbot'),
  );

// number of team members on an account excluding chatbot
export const selectNumberOfActiveTeamMembersWithoutChatbot = createSelector(
  'selectTeamMembersByCurrentOrganizationSortedByDisabledWithoutChatbot',
  (teamMembers) => getNumberOfActiveMembers(teamMembers),
);
